exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".player__overlay__1_w45{z-index:125;background-color:#000}.player__overlay__1_w45,.player__player__Upu_1{position:relative}.player__player__Upu_1{background:#000}.player__player__Upu_1 .player__player-wrapper__3Msyw{position:absolute;width:100%;height:100%;top:0}", ""]);

// exports
exports.locals = {
	"overlay": "player__overlay__1_w45",
	"player": "player__player__Upu_1",
	"player-wrapper": "player__player-wrapper__3Msyw",
	"playerWrapper": "player__player-wrapper__3Msyw"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/new-player/player.styl
// module id = 1644
// module chunks = 1 2 3